if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cartNotification = document.querySelector('cart-notification');
      }

      checkForFreeGiftAdding(cart, callback) {
        if(window.free_gift_enabled
        && window.free_gift_product_variant_id 
        && free_gift_product_variant_id  != '' 
        && window.free_gift_threshold
        && window.free_gift_threshold > 0) {
          if(window.free_gift_threshold * 100 <= cart.total_price) {
            if(window.free_gift_target_country_code != '' && window.free_gift_target_country_code != 'all') {
              if(typeof callback == 'function') {
                callback(cart);
              }
            } else {
              let gift_variant_id = window.free_gift_product_variant_id;
              let free_gift_already_in_cart = false;
              for(let i in cart.items) {
                let item = cart.items[i];
                console.log('item.variant_id');
                console.log(item.variant_id);
                if(item.variant_id == gift_variant_id) {
                  free_gift_already_in_cart = true;
                  break;
                }
              }
              if(!free_gift_already_in_cart) {
                $.post('/cart/add.json', {items: [{id: gift_variant_id, quantity: 1}]}, function (response) {
                  console.log('response');
                  console.log(response);
                  if(typeof callback == 'function') {
                    callback(cart);
                  }    
                });
              } else {
                if(typeof callback == 'function') {
                  callback(cart);
                }    
              }
            }
          } else {
            if(typeof callback == 'function') {
              callback(cart);
            }    
          }
        } else {
          if(typeof callback == 'function') {
            callback(cart);
          }  
        }
      }
  
      onSubmitHandler(evt) {
        evt.preventDefault();

        // Travel Compendium: Check if this is an 88ml variant and modal should show
        if (this.shouldShowTravelCompendiumModal()) {
          this.openTravelCompendiumModal();
          return;
        }

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            
            var _this = this;
            $.getJSON("/cart", function(cart) {
              console.log("cart")
              console.log(cart)

              _this.checkForFreeGiftAdding(cart, function (cart) {
                if (window.cart_popup) {
                  let check_engraving = window.cart_popup.checkEngraving(cart);
                  if (check_engraving.counters_check) {
                    window.cart_popup.updateCartPopup(function () {
                      $('.cart-popup-wrapper').addClass('open');
                      $('html').removeClass('cart-popup-wrapper-open');
                      $('html').addClass('cart-popup-wrapper-open');
                    });
                  } else {
                    window.cart_popup.handleEngraving(check_engraving.counter, check_engraving.counter_2, function() {
                      window.cart_popup.updateCartPopup(function () {
                        $('.cart-popup-wrapper').addClass('open');
                        $('html').removeClass('cart-popup-wrapper-open');
                        $('html').addClass('cart-popup-wrapper-open');
                      });
                    });
                  }
                }
              });

            });            
            
            //this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Travel Compendium Methods
      shouldShowTravelCompendiumModal() {
        // Check if Travel Compendium is enabled
        if (!window.travelCompendium || !window.travelCompendium.enabled) {
          return false;
        }

        // Check if this product form is eligible (has 88ml variant)
        const variant88mlId = this.dataset['88mlVariantId'];
        if (!variant88mlId) {
          return false;
        }

        // Check if the selected variant is the 88ml variant
        const variantInput = this.form.querySelector('input[name="id"]');
        const selectedVariantId = variantInput ? variantInput.value : null;

        if (String(selectedVariantId) !== String(variant88mlId)) {
          return false;
        }

        // Check if already declined for this product
        const productId = this.dataset.productId;
        const declinedKey = 'oj_tc_declined';
        try {
          const declined = JSON.parse(sessionStorage.getItem(declinedKey) || '[]');
          if (declined.includes(String(productId))) {
            return false;
          }
        } catch (e) {
          // Ignore storage errors
        }

        return true;
      }

      openTravelCompendiumModal() {
        if (window.TravelCompendium) {
          const productId = this.dataset.productId;
          const productTitle = this.dataset.productTitle;
          const variantInput = this.form.querySelector('input[name="id"]');
          const variantId = variantInput ? variantInput.value : null;

          window.TravelCompendium.currentProductId = productId;
          window.TravelCompendium.currentProductTitle = productTitle;
          window.TravelCompendium.currentVariantId = variantId;
          window.TravelCompendium.current88mlVariantId = this.dataset['88mlVariantId'];
          window.TravelCompendium.productFormElement = this;
          window.TravelCompendium.open();
        }
      }

      // Called by Travel Compendium after modal interaction to proceed with add-to-cart
      proceedWithAddToCart() {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            var _this = this;
            $.getJSON("/cart", function(cart) {
              _this.checkForFreeGiftAdding(cart, function (cart) {
                if (window.cart_popup) {
                  window.cart_popup.updateCartPopup(function () {
                    $('.cart-popup-wrapper').addClass('open');
                    $('html').removeClass('cart-popup-wrapper-open');
                    $('html').addClass('cart-popup-wrapper-open');
                  });
                }
              });
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
      }
    });
}
  